import _ from 'lodash';
import { INIT_DOC_EMPTY_TAB } from './constans';
import moment from 'moment';

export function getDocPageId(docId, pageNr, windowIdx = 0) {
    return `dp_${docId}_${pageNr}_${windowIdx}`;
}
export function decodeDocPageId(id) {
    const numbers = id.split('_');
    return { docId: numbers[1], page: numbers[2] };
}

export function getTabViewerWindowId(tabId, windowIdx) {
    return `tvw_${tabId}_${windowIdx}`;
}

export function getTabId(docId) {
    return `tab_${docId}`;
}

export function buildTab(document, annotations) {
    let newTab = _.cloneDeep(INIT_DOC_EMPTY_TAB);
    newTab.tabId = getTabId(document.id);
    newTab.documentData = document;
    newTab.tabName = document.originalFilename;
    newTab.tabDocDate = moment(_.get(document, 'date', ''), 'YYYY-MM-DDThh:mm:ssZ');
    newTab.docType = _.get(document, 'type.name', 'other');
    newTab.docTab = _.get(document, 'type.tabs[0].name', 'other');
    newTab.docKind = _.get(document, 'docKind', 'EMPTY');
    newTab.documentAnnotations = annotations && Array.isArray(annotations) ? annotations : [];
    return newTab;
}
